import { request } from '@umijs/max';
import { leaveMessageParamsType } from '@/pages/ServicesMore/interface';
import { RequestType } from '@/interface';

/**
 * 留言分页列表
 * @param params
 */
export const queryMessageList = async (params: leaveMessageParamsType) => {
  return request<Promise<RequestType<any>>>(
    '/api/community/wechat/WechatMessage/page',
    {
      method: 'get',
      params,
    },
  );
};

/**
 * 新增留言
 * @param data
 */
export const queryCreateMessage = async (data: any) =>
  request<Promise<RequestType<any>>>('/api/community/wechat/WechatMessage', {
    method: 'POST',
    data,
  });

/**
 * 留言详情
 * @param id
 */
export const queryLeaveMessageDetail = async (id: string) =>
  request<Promise<RequestType<any>>>(
    `/api/community/wechat/WechatMessage/${id}`,
    {
      method: 'GET',
    },
  );
